import React from 'react';
import '../AutomationBlocked.css';

const AutomationBlocked = () => (
  <div className="automation-blocked" role="alert">
    <div className="automation-blocked__card">
      <svg
        className="automation-blocked__icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        aria-hidden
      >
        <circle cx="12" cy="12" r="9" />
        <line x1="12" y1="8" x2="12" y2="13" />
        <circle cx="12" cy="16.5" r="0.8" fill="currentColor" stroke="none" />
      </svg>
      <h1>Access blocked</h1>
      <p>
        This session was flagged as an automated browser and cannot continue.
        Please open the app in a regular browser without automation tools.
      </p>
      <p>If you believe this is a mistake, contact support.</p>
    </div>
  </div>
);

export default AutomationBlocked;
